"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpedionLastPositionResponseSchema = exports.SpedionLastPositionSchema = exports.SpedionFmsSchema = exports.SpedionPositionSchema = exports.SpedionVehicleSchema = void 0;
const zod_1 = require("zod");
exports.SpedionVehicleSchema = zod_1.z.object({
    VehicleId: zod_1.z.number().int(),
    Name: zod_1.z.string().nullable().optional(),
    Numberplate: zod_1.z.string().nullable().optional(),
});
exports.SpedionPositionSchema = zod_1.z.object({
    Latitude: zod_1.z.number().nullable().optional(),
    Longitude: zod_1.z.number().nullable().optional(),
    Altitude: zod_1.z.number().nullable().optional(),
    Direction: zod_1.z.number().nullable().optional(),
});
exports.SpedionFmsSchema = zod_1.z.object({
    Odometer: zod_1.z.number().nullable().optional(),
    Speed: zod_1.z.number().nullable().optional(),
    FuelLevel: zod_1.z.number().nullable().optional(),
    TotalFuel: zod_1.z.number().nullable().optional(),
    ServiceDistance: zod_1.z.number().nullable().optional(),
});
exports.SpedionLastPositionSchema = zod_1.z.object({
    Vehicle: exports.SpedionVehicleSchema.nullable().optional(),
    Position: exports.SpedionPositionSchema.nullable().optional(),
    Fms: exports.SpedionFmsSchema.nullable().optional(),
    MessageTime: zod_1.z.string(),
});
exports.SpedionLastPositionResponseSchema = zod_1.z.object({
    ResultCode: zod_1.z.union([zod_1.z.literal(0), zod_1.z.literal(1)]),
    ErrorDescription: zod_1.z.string().nullable().optional(),
    Data: zod_1.z
        .object({
        LastRefresh: zod_1.z.string().nullable().optional(),
        VehiclePositions: zod_1.z.array(exports.SpedionLastPositionSchema).nullable().optional(),
    })
        .nullable()
        .optional(),
});
//# sourceMappingURL=spedion.js.map